import { Accordion, Text, Container, Title, Badge } from "@mantine/core";
import { FiBriefcase, FiCalendar, FiMail } from "react-icons/fi";

const SectionFive = () => {
  //const theme = useMantineTheme();

  return (
    <section id="section-five">
      <Container>
        <div style={{ marginBottom: 30 }}>
          <div style={{ textAlign: "left" }}>
            <Badge variant="filled" color="yellow">
              FAQs
            </Badge>
          </div>
          <Text color="black">
            <Title order={1} style={{ marginTop: 10 }}>
              Here are some FAQs for you!
            </Title>
          </Text>
        </div>

        <Accordion variant="contained">
          <Accordion.Item value="item1">
            <Accordion.Control
              icon={<FiBriefcase size={20} color={"#fab005"} />}
            >
              How can healthcare organizations ensure secure data sharing?
            </Accordion.Control>
            <Accordion.Panel>
              With the rise of interoperability, sharing health records has
              become easier than ever. However, it is important to ensure that
              the data privacy and security of the patients are not compromised
              in this process. In order to guarantee data privacy and security
              when sharing health records, organizations must take certain
              measures such as implementing strong authentication measures and
              encryption protocols. Additionally, organizations should also
              limit access to the data only to authorized personnel and
              regularly monitor any changes made to the data. By following these
              steps, organizations can ensure that their patients' health
              records remain secure when shared through interoperability.
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item value="item2">
            <Accordion.Control
              icon={<FiCalendar size={20} color={"#fab005"} />}
            >
              What technologies are available to facilitate interoperability in
              healthcare?
            </Accordion.Control>
            <Accordion.Panel>
              In the healthcare industry, interoperability is a key factor in
              improving patient outcomes and reducing costs. To achieve this,
              health organizations are increasingly turning to technologies such
              as APIs, data exchange standards, blockchain and cloud computing
              to facilitate collaboration between different systems and make
              data more accessible. This has resulted in improved efficiency and
              cost savings for healthcare providers.
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item value="item3">
            <Accordion.Control icon={<FiMail size={20} color={"#fab005"} />}>
              How can patient identification be improved to facilitate
              interoperability?
            </Accordion.Control>
            <Accordion.Panel>
              The ability to accurately identify and verify patients is a
              critical component of healthcare interoperability. As healthcare
              organizations move towards digital transformation, patient
              identification technology provides a solution that can help bridge
              the gap between disparate systems and ensure data accuracy. This
              paper will discuss how patient identification can be improved to
              facilitate interoperability, including the use of biometrics,
              blockchain technology, and other methods. It will also explore the
              potential use cases of these technologies in improving patient
              identification processes and how this could lead to better
              healthcare outcomes.
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      </Container>
    </section>
  );
};

export default SectionFive;
